/**
 * The one URL contract of presenter mode. The trainer's main window is served
 * at `/{liveSessionId}` as always; the presentation window it opens is the
 * same app at `/{liveSessionId}?view=projector&p={presentation}`, where
 * `presentation` is a random id per Present click that names the bridge
 * channel, so two presentations - or two tabs - never hear each other.
 */
export type WindowView =
	| { role: 'host' }
	| { role: 'projector'; presentation: string }

const VIEW = 'view'
const PRESENTATION = 'p'
const PROJECTOR = 'projector'

export const parseWindowView = (search: string): WindowView => {
	const params = new URLSearchParams(search)
	const presentation = params.get(PRESENTATION)
	return params.get(VIEW) === PROJECTOR && presentation
		? { role: 'projector', presentation }
		: { role: 'host' }
}

export const projectorPath = (
	liveSessionId: string,
	presentation: string
): string => {
	const params = new URLSearchParams({
		[VIEW]: PROJECTOR,
		[PRESENTATION]: presentation,
	})
	return `/${encodeURIComponent(liveSessionId)}?${params.toString()}`
}

export const bridgeChannelName = (
	liveSessionId: string,
	presentation: string
): string => `beelday-presenter:${liveSessionId}:${presentation}`

/** The `window.open` target name: one presentation window per session. */
export const projectorWindowName = (liveSessionId: string): string =>
	`beelday-projector-${liveSessionId}`
